import {
  getQueryParam,
  getReferrerQueryString,
  generateUUID
} from '@/utils/common.js';

let customAuthentication = getQueryParam('customAuthentication') && decodeURIComponent(getQueryParam('customAuthentication'));
let sourceType = getQueryParam('sourceType');

export default {
  netNimStatus: 'connect',
  notScroll: false,
  // 打开类型（tell值为1表示单独通过连接打开聊天页面）
  tell: getQueryParam('tell'),
  // 机构编号
  siteId: getQueryParam('siteId') ? window.atob(decodeURIComponent(getQueryParam('siteId'))) : getQueryParam('siteId'),
  // 机构编号
  companyId: getQueryParam('link') ? window.atob(decodeURIComponent(getQueryParam('companyId'))) : getQueryParam('companyId'),
  // 子渠道编号
  childChannelId: getQueryParam('link') ? window.atob(decodeURIComponent(getQueryParam('childChannelId'))) : getQueryParam('childChannelId'),
  // 会话标识id
  groupConversationId: getQueryParam('groupConversationId'),
  isOldUser: getQueryParam('o'), // 验证是够存储当前账号信息
  link: getQueryParam('link'), // 布尔值 打开留言板
  visitSign: getQueryParam('sign'), // 访客账号
  yunduoId: getQueryParam('yunduoId'), // 访客账号
  customParam: getQueryParam('customParam'),
  humanChatMessageNotice: JSON.parse(getQueryParam('humanChatMessageNotice')),
  visitName: getQueryParam('name'), // 访客昵称
  visitToken: getQueryParam('token'), // 访客Toke
  online: getQueryParam('online'),
  CT: getQueryParam('CT'),
  CH: getQueryParam('CH'),
  SR: getQueryParam('SR'),
  sourceKeyword: getQueryParam('sourceKeyword'),
  xst: getQueryParam('link') ? (getReferrerQueryString('xst') || getReferrerQueryString('bd_bxst')) : getQueryParam('xst'),
  // 聊天窗口的配置信息
  chatConfig: {
    type: 1, //9：聊天窗口样式（1标准，2迷你，3宽屏侧栏）
    color: '#2C80FF', //10：颜色（默认#2C80FF）
    placeholder: '', //12：聊天发送内容窗口的placeholder
    rightVisibile: false, //13：标准聊天窗口的右侧栏是否展示
    rightText: {
      type: '1',
      customerServiceValue: ''
    },
    topImg: '',
    topImgVisibile: false,
    logoImgVisibile: false,
    logoData: null,
    manualFlag: false,
    tipsVisible: 0,
    tipsSelfVisible: 0,
    tipsSelfContent: ''
  },

  // 当前访客信息
  myInfo: {},
  // NIM SDK 实例
  nim: null,
  // 访客对话过的客服会话列表
  sessionList: [],
  // 访客对应的对话过的客服列表名片信息
  sessionUserMap: {},
  sessionMap: {},
  currSessionId: '',
  currSession: {},
  currSessionMsgs: [],
  currSessionLastMsg: {},
  customerServiceId: '',
  // 以sessionId作为key
  msgs: {},

  // 页面逻辑相关
  // currSessionStatus: 0,
  // 和客服聊天时的对话id
  currSessionConversationId: '',
  // 和客服聊天时发送消息需要的第一次标识
  currSessionFirstFlag: true,
  // 和客服正在聊天的对话是否需要重连
  currSessionReConnect: false,
  // 访客会话的第一次消息标识
  visitorFirstFlagMap: {},
  // 加载状态
  loading: false,
  eventLoading: false,
  webtype: 'web',
  // 发送消息时需要的自定义参数
  msgCustom: {},
  // 重新建立链接前发送的第一条消息
  reconnectFirstMsg: null,
  // 客服正在输入的状态
  customerServiceInputStatus: false,
  // 访客发送的失败消息
  sendFailMsgObj: null,
  // 测试功能添加数据
  customAuthentication: customAuthentication && JSON.parse(customAuthentication),
  sourceType: sourceType,
  // 上报请求日志的唯一标识
  globalUnique: getQueryParam('visitorFirstGlobalUnique') ? getQueryParam('visitorFirstGlobalUnique') : generateUUID() + ",chat",
  // 移动/PC区分
  originaType: getQueryParam('originalW') || "noIdentify",
  // 部署类型
  delopType: getQueryParam('delopType') || "independentOpen",
  // 当前URL
  url: getQueryParam('url') && decodeURIComponent(getQueryParam('url')) || "",
}



// WEBPACK FOOTER //
// ./src/store/modules/im/state.js